export default __webpack_public_path__ + "static/media/Maithili_bm_1.0f0ae04a.mp3";